<template>
    <div class="block-content block-content-full overflow-hidden mb-2 rounded-12">
        <div class="block w-80">
            <div class="block-header pb-4">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">
                    {{
                        (Array.isArray(data) ? data.length > 0 : Object.keys(data).length > 0)
                            ? $t('combo.edit_title')
                            : $t('combo.add_title')
                    }}
                    <!--<span data-tooltip data-tooltip-right :data-tooltip-message="descriptions.general">
                        <i class="fas fa-info-circle"></i>
                    </span>-->
                </h3>
            </div>
            <div class="row justify-content-center">
                <div class="col-sm-10 col-md-11">
                    <div class="row justify-content-center">
                        <form @submit.prevent="handleSubmit">
                            <!-- Combo Name -->
                            <div class="col-12 col-md-12">
                                <label for="name" class="form-label mt-2"
                                    >{{ $t('combo.name_label') }}<span class="text-purple">*</span></label
                                >
                                <input
                                    type="text"
                                    class="form-control fs-6 py-2"
                                    id="name"
                                    v-model="formData.name"
                                    :placeholder="$t('combo.name_placeholder')"
                                />
                                <div v-if="errors.name" class="invalid-feedback">{{ errors.name }}</div>
                            </div>

                            <!-- Description -->
                            <div class="col-12 col-md-12">
                                <label class="form-label" for="description"
                                    >{{ $t('combo.description_label') }}<span class="text-purple">*</span></label
                                >
                                <div ref="editor" class="editor-container"></div>
                                <div v-if="errors.description" class="invalid-feedback">{{ errors.description }}</div>
                            </div>

                            <!-- Visibility Toggle -->
                            <div class="col-12 col-md-12 mt-4">
                                <div
                                    class="form-check form-switch form-check-inline w-100 rounded-12 px-3 d-flex align-items-center"
                                >
                                    <BaseSwitch
                                        id="visible_online"
                                        v-model="formData.visible_online"
                                        :label-left="$t('combo.visible_online_label')"
                                        :error="errors.visible_online"
                                    />
                                </div>
                            </div>

                            <!-- Image Upload -->
                            <div class="col-12 mt-4">
                                <label class="form-label pb-2" for="image">{{ $t('combo.illustration_label') }}</label>
                                <div
                                    class="form-control overflow-hidden text-center new-image"
                                    style="cursor: pointer; padding-top: 33px"
                                >
                                    <input type="file" id="image-input" hidden @change="handleImageUpload" accept="image/*" />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="29"
                                        height="24"
                                        viewBox="0 0 29 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.33321 19.0016C5.66958 19.0016 4.07409 18.3694 2.89772 17.2442C1.72136 16.119 1.06049 14.5929 1.06049 13.0016C1.06049 11.4103 1.72136 9.88414 2.89772 8.75892C4.07409 7.6337 5.66958 7.00156 7.33321 7.00156C7.72613 5.25113 8.87556 3.71287 10.5287 2.72518C11.3472 2.23613 12.2647 1.89696 13.2289 1.72705C14.1931 1.55713 15.185 1.5598 16.148 1.7349C17.1111 1.90999 18.0263 2.25409 18.8416 2.74754C19.6569 3.24098 20.3562 3.87412 20.8996 4.6108C21.443 5.34748 21.8198 6.17327 22.0086 7.04102C22.1974 7.90878 22.1944 8.8015 21.9999 9.66823H23.3332C24.5709 9.66823 25.7579 10.1599 26.633 11.0351C27.5082 11.9102 27.9999 13.0972 27.9999 14.3349C27.9999 15.5726 27.5082 16.7596 26.633 17.6347C25.7579 18.5099 24.5709 19.0016 23.3332 19.0016H21.9999"
                                            stroke="#021832"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M9.99988 15L13.9999 11L17.9999 15"
                                            stroke="#021832"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M13.9999 11V23"
                                            stroke="#021832"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>

                                    <label for="image-input" class="form-control text-center" style="cursor: pointer">{{
                                        $t('combo.upload_image')
                                    }}</label>
                                    <img
                                        v-if="imagePreview"
                                        :src="imagePreview"
                                        class="border-0 rounded-12"
                                        style="width: 360px"
                                    />
                                    <div v-if="errors.image" class="invalid-feedback">{{ errors.image }}</div>
                                </div>
                            </div>

                            <!-- Combo Type Selection -->
                            <div class="row justify-content-center mt-2" style="display: none">
                                <div class="col-12">
                                    <label class="form-label mb-0" for="image_prestations"
                                        >{{ $t('combo.type_label') }}<span class="text-purple">*</span></label
                                    >
                                </div>
                                <div class="row">
                                    <div class="col-12 col-lg-4 col-xs-12" v-for="(option, index) in comboOptions" :key="index">
                                        <div
                                            class="radio-container"
                                            :class="{ 'combo-selected-container': option.value == formData.type }"
                                            @change="handleComboOptionChange(option.value)"
                                        >
                                            <input
                                                type="radio"
                                                class="combo-items-radio"
                                                :class="{
                                                    'combo-items-radio-selected': option.value == formData.type,
                                                }"
                                                :id="`option-combo-type-${index}`"
                                                :name="`radio-group-type`"
                                                v-model="formData.type"
                                                @change="handleComboOptionChange(option.value)"
                                                :disabled="!option.isActive"
                                            />

                                            <label
                                                class="form-check-label mb-0 text_dark_blue"
                                                :for="`option-combo-type-${index}`"
                                                >{{ option.label }}
                                                <span
                                                    data-tooltip
                                                    :data-tooltip-left="index == 2 ? true : undefined"
                                                    :data-tooltip-right="index != 2 ? true : undefined"
                                                    :data-tooltip-message="option.description"
                                                >
                                                    <i class="fas fa-info-circle"></i>
                                                </span>
                                            </label>
                                            <p class="text-muted radio-description">
                                                {{ shortDescription(option.description) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="errors.type" class="invalid-feedback">{{ errors.type }}</div>
                            </div>

                            <div class="row justify-content-center py-md-4 py-lg-4" v-if="formData.type != 'allPrestations'">
                                <div class="col-sm-12 col-md-12">
                                    <div class="row">
                                        <!-- Durée entre activités -->
                                        <div class="col-12">
                                            <div class="mb-2">
                                                <label class="form-label" for="slot_succession"
                                                    >{{ $t('combo.slot_succession_label') }}
                                                    <span
                                                        data-tooltip
                                                        data-tooltip-right
                                                        :data-tooltip-message="$t('combo.slot_succession_help')"
                                                    >
                                                        <i class="fas fa-info-circle"></i>
                                                    </span>
                                                </label>
                                                <input
                                                    type="number"
                                                    min="-1"
                                                    step="1"
                                                    class="form-control"
                                                    v-model="formData.slot_succession"
                                                    @input="validateSlotSuccession"
                                                    :placeholder="$t('combo.slot_succession_placeholder')"
                                                />
                                                <div v-if="errors.slot_succession" class="invalid-feedback">
                                                    {{ errors.slot_succession }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Some time -->
                            <div class="col-12 mb-2 mt-5">
                                <label class="form-label" for="is_same_time">
                                    {{ $t('combo.same_time_question') }}<span class="text-purple">*</span>
                                    <span data-tooltip data-tooltip-right :data-tooltip-message="$t('combo.same_time_help')">
                                        <i class="fas fa-info-circle"></i>
                                    </span>
                                </label>
                                <div class="row">
                                    <div
                                        class="col-12 col-lg-6 col-xs-12"
                                        v-for="(option, index) in someTimeOptions"
                                        :key="index"
                                    >
                                        <div
                                            class="radio-container"
                                            :class="{
                                                'combo-selected-container': option.value == formData.is_same_time,
                                            }"
                                            @change="handleSomeTimeOptionChange(option.value)"
                                        >
                                            <input
                                                type="radio"
                                                class="combo-items-radio"
                                                :class="{
                                                    'combo-items-radio-selected': option.value == formData.is_same_time,
                                                }"
                                                :id="`option-some-time-${index}`"
                                                :name="`radio-group-some-time`"
                                                v-model="formData.is_same_time"
                                                @change="handleSomeTimeOptionChange(option.value)"
                                                :disabled="!option.isActive"
                                            />

                                            <label
                                                class="form-check-label mb-0 text_dark_blue"
                                                :for="`option-some-time-${index}`"
                                                >{{ option.label }}</label
                                            >
                                            <p class="text-muted radio-description">
                                                {{ option.description }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="errors.is_same_time" class="invalid-feedback">
                                    {{ errors.is_same_time }}
                                </div>
                            </div>

                            <!-- Multi participants -->
                            <div class="col-12 mb-2 mt-4" v-if="formData.type == 'family'">
                                <label class="form-label" for="is_multi_participants">
                                    {{ $t('combo.multi_participants_question') }}
                                    <span class="text-purple">*</span>
                                </label>
                                <div class="row">
                                    <div
                                        class="col-12 col-lg-6 col-xs-12"
                                        v-for="(option, index) in multiParticipantsOptions"
                                        :key="index"
                                    >
                                        <div
                                            class="radio-container"
                                            :class="{
                                                'combo-selected-container': option.value == formData.is_multi_participants,
                                            }"
                                            @change="handleMultiParticipantsOptionChange(option.value)"
                                        >
                                            <input
                                                type="radio"
                                                class="combo-items-radio"
                                                :class="{
                                                    'combo-items-radio-selected': option.value == formData.is_multi_participants,
                                                }"
                                                :id="`option-multi-participants-${index}`"
                                                :name="`radio-group-multi-participants`"
                                                v-model="formData.is_multi_participants"
                                                @change="handleMultiParticipantsOptionChange(option.value)"
                                                :disabled="!option.isActive"
                                            />

                                            <label
                                                class="form-check-label mb-0 text_dark_blue"
                                                :for="`option-multi-participants-${index}`"
                                                >{{ option.label }}</label
                                            >
                                            <p class="text-muted radio-description">
                                                {{ option.description }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="errors.is_multi_participants" class="invalid-feedback">
                                    {{ errors.is_multi_participants }}
                                </div>
                            </div>

                            <!-- Discount Section -->
                            <div v-if="formData.type == 'allPrestations-'">
                                <div class="block-header pt-0 fixed-price-specific-activites">
                                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue my-4">
                                        {{ $t('combo.discounts_title') }}
                                    </h3>
                                </div>

                                <div class="fixed-price-specific-activites">
                                    <div class="row justify-content-center py-md-3 py-lg-1">
                                        <div class="col-sm-12 col-md-12">
                                            <div class="row justify-content-center" id="presta_deposite_input">
                                                <div class="col-6 col-lg-6 col-xs-12">
                                                    <label class="form_label2" for="discount_type"
                                                        >{{ $t('combo.discount_type') }}<span class="text-purple">*</span></label
                                                    >
                                                    <div class="input-group rounded-24">
                                                        <select
                                                            class="fs-6 select2 form-select form-control"
                                                            id="discount_type"
                                                            v-model="formData.discount_type"
                                                            style="width: 100%"
                                                        >
                                                            <option value="">{{ $t('combo.select_type') }}</option>
                                                            <option
                                                                v-for="type in discountTypes"
                                                                :key="type.value"
                                                                :value="type.value"
                                                            >
                                                                {{
                                                                    type.value == 'amount'
                                                                        ? $t('combo.amount')
                                                                        : ucfirst(type.value)
                                                                }}
                                                                <span id="symbol">
                                                                    <span v-if="type.value == 'percentage'"> (%) </span>
                                                                    <span v-if="type.value == 'amount'">
                                                                        ({{ $symbolCurrency }})
                                                                    </span>
                                                                </span>
                                                            </option>
                                                        </select>
                                                        <div v-if="errors.discount_type" class="invalid-feedback">
                                                            {{ errors.discount_type }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-lg-6 col-xs-12">
                                                    <label class="form_label2" for="discount_value"
                                                        >{{ $t('combo.value') }}<span class="text-purple">*</span></label
                                                    >
                                                    <input
                                                        v-model="formData.discount_value"
                                                        type="number"
                                                        min="0"
                                                        step="any"
                                                        class="fs-6 form-control"
                                                        id="discount_value"
                                                        :placeholder="$t('combo.value')"
                                                    />
                                                    <div v-if="errors.discount_value" class="invalid-feedback">
                                                        {{ errors.discount_value }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="formData.type == 'specificPrestation' || formData.type == 'family'"
                                class="package-items-block"
                            >
                                <div class="block-header pt-4">
                                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">
                                        {{ $t('combo.elements_title') }}
                                    </h3>
                                </div>

                                <div class="row justify-content-center py-md-4 py-lg-4">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="row">
                                            <!-- Nombre des elements (min) -->
                                            <div class="col-6">
                                                <div class="mb-2">
                                                    <label class="form-label" for="item_qty_min"
                                                        >{{ $t('combo.min_elements_label') }}
                                                        <span
                                                            data-tooltip
                                                            data-tooltip-right
                                                            :data-tooltip-message="$t('combo.min_elements_help')"
                                                        >
                                                            <i class="fas fa-info-circle"></i>
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="-1"
                                                        step="1"
                                                        class="form-control"
                                                        v-model="formData.item_qty_min"
                                                        @input="validateItemQtyMin"
                                                        :placeholder="$t('combo.elements_qty_placeholder')"
                                                    />
                                                    <div v-if="errors.item_qty_min" class="invalid-feedback">
                                                        {{ errors.item_qty_min }}
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Nombre des elements (max) -->
                                            <div class="col-6">
                                                <div class="mb-2">
                                                    <label class="form-label" for="item_qty_max"
                                                        >{{ $t('combo.max_elements_label') }}
                                                        <span
                                                            data-tooltip
                                                            data-tooltip-right
                                                            :data-tooltip-message="$t('combo.max_elements_help')"
                                                        >
                                                            <i class="fas fa-info-circle"></i>
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="-1"
                                                        step="1"
                                                        class="form-control"
                                                        v-model="formData.item_qty_max"
                                                        @input="validateItemQtyMax"
                                                        :placeholder="$t('combo.elements_qty_placeholder')"
                                                    />
                                                    <div v-if="errors.item_qty_max" class="invalid-feedback">
                                                        {{ errors.item_qty_max }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12" style="margin: 0; padding: 0">
                                                <small class="ml-4">
                                                    <i>{{ $t('combo.elements_qty_empty_help') }}</i>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Display whether durations are the same or not -->
                                <p v-if="!areDurationsSame && formData.is_same_time" class="text-warning">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-exclamation-triangle"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"
                                        />
                                        <path
                                            d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"
                                        />
                                    </svg>
                                    <span v-html="$t('combo.durations_diff_warning')"></span>
                                </p>

                                <p v-if="hasNullSelectedDuration" class="text-warning">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-exclamation-triangle"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"
                                        />
                                        <path
                                            d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"
                                        />
                                    </svg>
                                    {{ $t('combo.null_duration_warning') }}
                                </p>

                                <div v-for="(item, index) in comboItems" :key="index" class="row mb-3">
                                    <!-- Activity Selection -->
                                    <div class="col-6 col-xs-8">
                                        <div class="form-group">
                                            <label :for="'select_activites_' + index" class="form-label">{{
                                                $t('combo.select_element_label', { index: index + 1 })
                                            }}</label>
                                            <span
                                                @click="toggleModalTicketOption(index)"
                                                class="btn ticket-option-toggle"
                                                v-if="hasTicketsOptions(index)"
                                            >
                                                {{ $t('combo.ticket_options') }}
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                >
                                                    <path
                                                        d="M3 6h12a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2Zm0 6h12a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2Zm0 6h12a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2Zm16.293-7.707a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414L19.586 13H16a1 1 0 0 1 0-2h3.586l-.293-.293a1 1 0 0 1 0-1.414Z"
                                                    />
                                                </svg>
                                            </span>

                                            <v-select
                                                class="v-select"
                                                :ref="'select_activites_ref_' + index"
                                                :id="'select_activites_' + index"
                                                v-model="item.selectedActivity"
                                                :options="getAvailableActivities(index)"
                                                label="name"
                                                hide-selected
                                                :get-option-label="(option) => option.name"
                                                :placeholder="$t('combo.select_activity')"
                                                @input="onActivityChange(index, item)"
                                                :class="{ 'is-invalid': errors.comboItems?.[index]?.activityId }"
                                                :dropdown-should-open="dropdownShouldOpen"
                                            >
                                                <template #option="{ name }">
                                                    {{ name }}
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        {{ $t('combo.no_results', { search: search }) }}.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">{{ $t('combo.no_elements') }}</em>
                                                </template>
                                            </v-select>
                                            <div v-if="errors.comboItems?.[index]?.activityId" class="invalid-feedback">
                                                {{ errors.comboItems[index].activityId }}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Duration Selection -->
                                    <div class="col-4 col-xs-4">
                                        <div class="form-group" v-if="!hasTicketsOptions(index)">
                                            <label :for="'select_activites_duration_' + index" class="form-label">{{
                                                $t('combo.duration')
                                            }}</label>
                                            <v-select
                                                class="v-select"
                                                :id="'select_activites_duration_' + index"
                                                v-model="item.selectedDuration"
                                                :options="getAvailableDurations(item.selectedActivity)"
                                                label="duration"
                                                hide-selected
                                                :get-option-label="(option) => option.duration"
                                                :placeholder="$t('combo.select_duration')"
                                                :class="{ 'is-invalid': errors.comboItems?.[index]?.durationId }"
                                            >
                                                <template #option="{ duration, price }">
                                                    {{ formatDurationPrice(duration, price) }}
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        {{ $t('combo.no_results', { search: search }) }}.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">{{ $t('combo.no_elements') }}</em>
                                                </template>
                                            </v-select>
                                            <div v-if="errors.comboItems?.[index]?.durationId" class="invalid-feedback">
                                                {{ errors.comboItems[index].durationId }}
                                            </div>
                                        </div>
                                        <div class="form-group mt-2" v-if="hasTicketsOptions(index)">
                                            <label class="form-label">{{ $t('combo.option_and_duration') }}</label>
                                            <div
                                                @click="toggleModalTicketOption(index)"
                                                class="btn btn-outline-primary"
                                                style="width: 100%; padding: 0.75rem"
                                            >
                                                <span v-if="item?.selectedDuration?.isTicketAsOption">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        width="20"
                                                        height="20"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            d="M3 6h12a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2Zm0 6h12a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2Zm0 6h12a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2Zm16.293-7.707a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414L19.586 13H16a1 1 0 0 1 0-2h3.586l-.293-.293a1 1 0 0 1 0-1.414Z"
                                                        />
                                                    </svg>
                                                    {{ item?.selectedDuration?.ticketAsOption?.name }} /
                                                    {{ item?.selectedDuration?.duration }} (min)
                                                </span>
                                                <span v-else>{{ $t('combo.select_option') }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-1 d-flex align-items-center justify-content-center">
                                        <div class="form-check form-switch mb-0 d-flex mt-4">
                                            <span
                                                data-tooltip
                                                data-tooltip-right
                                                :data-tooltip-message="$t('combo.required_item')"
                                            >
                                                <i class="fas fa-info-circle"></i>
                                            </span>
                                            <input
                                                class="form-control form-check-input mt-1 ms-3"
                                                type="checkbox"
                                                v-model="item.isRequired"
                                            />
                                        </div>
                                    </div>

                                    <!-- Remove Button -->
                                    <div class="col-1 d-flex align-items-center justify-content-center">
                                        <button
                                            type="button"
                                            class="btn btn-danger btn-sm mt-4"
                                            @click="removeCombo(index)"
                                            :title="$t('common.remove')"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                </div>

                                <!-- Add Combo Button -->
                                <div v-if="comboItems.length < maxcomboItems" class="d-flex justify-content-center mt-3">
                                    <span
                                        @click="addCombo()"
                                        :disabled="comboItems.length >= maxcomboItems"
                                        class="btn btn-primary"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                        >
                                            <path
                                                d="M12 2a1 1 0 0 1 1 1v8h8a1 1 0 1 1 0 2h-8v8a1 1 0 1 1-2 0v-8H3a1 1 0 1 1 0-2h8V3a1 1 0 0 1 1-1Z"
                                            />
                                        </svg>
                                        {{ $t('combo.addButton') }}
                                    </span>
                                </div>

                                <!-- Classement obligatoire -->
                                <div class="col-12 mb-2 mt-5">
                                    <label class="form-label" for="is_same_time">
                                        {{ $t('combo.order_required_question') }}<span class="text-purple">*</span>
                                        <!-- <i
                                            class="fas fa-info-circle"
                                            style="cursor: pointer; margin-left: 5px"
                                            :title="descriptions.is_order_required"
                                        ></i> -->
                                    </label>
                                    <div class="row">
                                        <div
                                            class="col-12 col-lg-6 col-xs-12"
                                            v-for="(option, index) in isOrderRequiredOptions"
                                            :key="index"
                                        >
                                            <div
                                                class="radio-container"
                                                :class="{
                                                    'combo-selected-container': option.value == formData.is_order_required,
                                                }"
                                                @change="handleIsOrderRequiredChange(option.value)"
                                            >
                                                <input
                                                    type="radio"
                                                    class="combo-items-radio"
                                                    :class="{
                                                        'combo-items-radio-selected': option.value == formData.is_order_required,
                                                    }"
                                                    :id="`option-is-order-required-${index}`"
                                                    :name="`radio-group-is-order-required`"
                                                    v-model="formData.is_order_required"
                                                    @change="handleIsOrderRequiredChange(option.value)"
                                                    :disabled="!option.isActive"
                                                />

                                                <label
                                                    class="form-check-label mb-0 text_dark_blue"
                                                    :for="`option-is-order-required-${index}`"
                                                    >{{ option.label }}</label
                                                >
                                                <p class="text-muted radio-description">
                                                    {{ option.description }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="errors.is_order_required" class="invalid-feedback">
                                        {{ errors.is_order_required }}
                                    </div>
                                </div>
                            </div>

                            <!-- Price and VAT Fields -->
                            <div
                                v-if="formData.type == 'specificPrestation' || !formData.is_by_percent"
                                class="price-and-vat-block"
                            >
                                <div class="block-header pt-2">
                                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mt-5">
                                        {{ $t('combo.price_vat_title') }}
                                    </h3>
                                </div>

                                <div class="row justify-content-center py-md-4 py-lg-4">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="row">
                                            <!-- Code-barres -->
                                            <div class="col-6 col-lg-6 col-xs-12">
                                                <div class="mb-2">
                                                    <label class="form-label" for="code_ean">{{ $t('combo.barcode') }}</label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        step="1"
                                                        class="form-control"
                                                        v-model="formData.code_ean"
                                                        :placeholder="$t('combo.barcode')"
                                                    />
                                                    <div v-if="errors.code_ean" class="invalid-feedback">
                                                        {{ errors.code_ean }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-6 col-xs-12">
                                                <label class="form-label" for="vat_rate">
                                                    {{ $t('combo.vat_rate') }}<span class="text-purple">*</span>
                                                </label>
                                                <div class="input-group rounded-12 overflow-hidden">
                                                    <select
                                                        v-model="formData.vat_rate"
                                                        class="form-select form-control"
                                                        @change="onVatRateChange()"
                                                        required
                                                    >
                                                        <option
                                                            v-for="vat in country_vat_rates"
                                                            :key="vat.id"
                                                            :value="vat.pourcentage"
                                                        >
                                                            {{ vat.pourcentage }} - {{ vat.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-6 col-xs-12">
                                                <label class="form-label" for="price">
                                                    {{ $t('combo.selling_price', { currency: $symbolCurrency }) }}
                                                    <span class="text-purple">*</span>
                                                </label>
                                                <div class="input-group rounded-12 overflow-hidden">
                                                    <input
                                                        type="text"
                                                        step="0.01"
                                                        class="form-control"
                                                        v-model="formData.price"
                                                        :placeholder="
                                                            $placeholderText($t('combo.selling_price', { currency: '' }))
                                                        "
                                                        @input="calculatePrice()"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-6 col-xs-12 d-none">
                                                <label class="form-label" for="price_ht">
                                                    {{ $t('combo.price_ht', { currency: $symbolCurrency })
                                                    }}<span class="text-purple">*</span>
                                                </label>
                                                <div class="input-group rounded-12 overflow-hidden">
                                                    <input
                                                        type="text"
                                                        step="any"
                                                        class="form-control"
                                                        v-model="formData.price_ht"
                                                        :placeholder="$placeholderText($t('combo.price_ht', { currency: '' }))"
                                                        required
                                                        @input="calculatePriceHT()"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Acompte Fields -->
                            <div class="pb-4" v-if="formData.type == 'specificPrestation' || !formData.is_by_percent">
                                <div class="block-header pt-2">
                                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">
                                        {{ $t('combo.deposit') }}
                                    </h3>
                                </div>

                                <div class="row justify-content-center mt-4">
                                    <div class="form-check form-switch mb-0 d-flex">
                                        <input
                                            class="form-control form-check-input mt-1 ms-3"
                                            type="checkbox"
                                            id="acompte"
                                            v-model="formData.deposite"
                                            @change="handleDepositeChange"
                                            style="margin-right: 10px"
                                        />
                                        <label class="form-check-label form_label2" for="acompte">
                                            {{ $t('combo.request_deposit') }}</label
                                        >

                                        <div v-if="errors.deposite" class="invalid-feedback">
                                            {{ errors.deposite }}
                                        </div>
                                    </div>
                                </div>

                                <div class="row justify-content-center mt-4" v-if="formData.deposite">
                                    <div class="col-6">
                                        <label class="form_label2" for="deposite_type">{{ $t('combo.deposit_type') }}</label>
                                        <div class="input-group rounded-24">
                                            <select
                                                class="fs-6 select2 form-select form-control"
                                                id="deposite_type"
                                                v-model="formData.deposite_type"
                                            >
                                                <option value="" disabled>{{ $t('combo.please_select') }}</option>
                                                <option v-for="type in depositTypes" :key="type.value" :value="type.value">
                                                    {{ type.label }}
                                                </option>
                                            </select>
                                            <div v-if="errors.deposite_type" class="invalid-feedback">
                                                {{ errors.deposite_type }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <label class="form_label2" for="deposite_value">{{ $t('combo.deposit') }}</label>
                                        <input
                                            v-model.number="formData.deposite_value"
                                            type="number"
                                            min="0"
                                            class="fs-6 form-control"
                                            id="deposite_value"
                                            :placeholder="$t('combo.deposit')"
                                        />
                                        <div v-if="errors.deposite_value" class="invalid-feedback">
                                            {{ errors.deposite_value }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- By Percent Field -->
                            <div v-if="formData.is_by_percent" class="price-and-vat-block mt-5">
                                <div class="block-header pt-2">
                                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">
                                        {{ $t('combo.discount') }}
                                    </h3>
                                </div>

                                <!-- Activier le remise -->
                                <div class="col-12 mb-2 mt-4">
                                    <label class="form-label" for="is_remise_percent_active">
                                        {{ $t('combo.activate_discount') }}<span class="text-purple">*</span>
                                    </label>
                                    <small>{{ $t('combo.discount_help') }}</small>
                                    <div class="row">
                                        <div
                                            class="col-12 col-lg-6 col-xs-12"
                                            v-for="(option, index) in remisePercentOptions"
                                            :key="index"
                                        >
                                            <div
                                                class="radio-container"
                                                :class="{
                                                    'combo-selected-container':
                                                        option.value === formData.is_remise_percent_active,
                                                }"
                                                @change="handleIsRemisePercentActiveChange(option.value)"
                                            >
                                                <input
                                                    type="radio"
                                                    class="combo-items-radio"
                                                    :class="{
                                                        'combo-items-radio-selected':
                                                            option.value === formData.is_remise_percent_active,
                                                    }"
                                                    :id="`option-is-remise-percent-active-${index}`"
                                                    :name="`radio-group-is-remise-percent-active`"
                                                    v-model="formData.is_remise_percent_active"
                                                    @change="handleIsRemisePercentActiveChange(option.value)"
                                                    :disabled="!option.isActive"
                                                />

                                                <label
                                                    class="form-check-label mb-0 text_dark_blue"
                                                    :for="`option-is-remise-percent-active-${index}`"
                                                    >{{ option.label }}</label
                                                >
                                                <p class="text-muted radio-description">
                                                    {{ option.description }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="errors.is_remise_percent_active" class="invalid-feedback">
                                        {{ errors.is_remise_percent_active }}
                                    </div>
                                </div>

                                <div class="row justify-content-center py-md-4 py-lg-4" v-if="formData.is_remise_percent_active">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="row">
                                            <!-- By Percent -->
                                            <div class="col-12 col-lg-12 col-xs-12">
                                                <div class="mb-2">
                                                    <label class="form-label" for="remise_percent">{{
                                                        $t('combo.discount_percent')
                                                    }}</label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        max="100"
                                                        step="1"
                                                        class="form-control"
                                                        v-model="formData.remise_percent"
                                                        :placeholder="$t('combo.discount_percent')"
                                                    />
                                                    <div v-if="errors.remise_percent" class="invalid-feedback">
                                                        {{ errors.remise_percent }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pb-4">
                                <div class="block-header pt-2">
                                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">
                                        {{ $t('combo.advanced_options') }}
                                    </h3>
                                </div>

                                <div class="row justify-content-center mt-4">
                                    <div class="col-12">
                                        <!-- Optionnel : pour contrôler la largeur -->

                                        <div class="option-group">
                                            <span style="color: #021832; margin-left: 20px; margin-bottom: 20px">{{
                                                $t('combo.merge_questions')
                                            }}</span>

                                            <div class="form-check form-switch mb-0 d-flex align-items-center gap-3 mt-2">
                                                <input
                                                    class="form-control form-check-input"
                                                    type="checkbox"
                                                    id="questions_are_merged"
                                                    v-model="formData.questions_are_merged"
                                                />
                                                <label class="form-check-label form_label2" for="questions_are_merged">
                                                    {{ $t('combo.merge_questions_help') }}
                                                </label>
                                            </div>

                                            <div v-if="errors.questions_are_merged" class="invalid-feedback d-block mt-1">
                                                {{ errors.questions_are_merged }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4 justify-content-center py-1 not-option">
                                <div class="col-12">
                                    <div class="block-header">
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-3">
                                            {{ $t('combo.categories_title') }}
                                        </h3>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="selected_tags" class="form-label">
                                                {{ $t('combo.choose_categories') }}</label
                                            >
                                            <v-select
                                                class="v-select"
                                                id="selected_tags"
                                                v-model="formData.selected_tags"
                                                :options="filteredTags"
                                                label="name"
                                                hide-selected
                                                multiple
                                                :get-option-label="(option) => option.name"
                                                placeholder=" Choisissez une ou plusieurs catégories"
                                                :aria-label="$t('combo.select_categories_aria')"
                                            >
                                                <template #option="{ name }">
                                                    {{ name }}
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        {{ $t('combo.no_results', { search: search }) }}.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">{{ $t('combo.no_elements') }}</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center mt-4 pt-2 gap-40 flex-wrap mx-6">
                                <a
                                    href="/back-office/package"
                                    class="btn btn-outline-dark line_height41 rounded-12 fw-semibold width-btn height_btn_page"
                                >
                                    {{ $t('common.cancel') }}
                                </a>
                                <button
                                    type="submit"
                                    :disabled="!areDurationsSame && formData.is_same_time"
                                    class="btn btn-dark rounded-12 fw-semibold width-btn height_btn_page"
                                >
                                    {{ this.data.id ? $t('common.save') : $t('common.add') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <modal
            name="modal-ticket-options"
            width="55%"
            height="55%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-exit" @click="toggleModalTicketOption()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M10.9512 1.0498L1.05168 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M1.05078 1.0498L10.9503 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>
            <div class="modal-ticket-option-list" v-if="hasTicketsOptions">
                <table class="block-content block-content-full">
                    <thead>
                        <tr>
                            <th>{{ $t('combo.ticket_options') }}</th>
                            <th>{{ $t('combo.duration') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in ticketsAsOption" :key="item.id">
                            <td class="pb-2">
                                {{ item.item_prestation.name }}
                            </td>
                            <td>
                                <div v-for="(option, index) in item.item_prestation.prices_by_times" :key="index" class="pb-2">
                                    <label>
                                        <input
                                            type="radio"
                                            name="radio-ticket-option"
                                            :value="option.id"
                                            class="form-check-input"
                                            :checked="ticketsAsOptionSelectedDurationId === option.id"
                                            @input="onPrestationOption(item.item_prestation, option)"
                                        />
                                        &nbsp;{{ formatDurationPrice(option.duration, option.price) }}
                                    </label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </modal>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import BaseSwitch from '../Shared/BaseSwitch.vue'
import 'vue-select/dist/vue-select.css'

export default {
    props: ['data', 'tags', 'country_vat_rates', 'package_items', 'prestations_with_prices_times'],
    data() {
        return {
            formData: {
                name: '',
                description: '',
                visible_online: true,
                type: 'family',
                price: 0,
                vat_rate: 0,
                code_ean: null,
                discount_type: '',
                discount_value: null,
                image: null,
                item_qty_min: null,
                item_qty_max: null,
                price_ht: 0,
                is_same_time: false,
                is_multi_participants: false,
                is_order_required: false,
                is_by_percent: false,
                slot_succession: null,
                remise_percent: null,
                is_remise_percent_active: false,
                selected_tags: [],
                deposite: false,
                deposite_type: '',
                deposite_value: '',
                questions_are_merged: false,
            },

            imagePreview: null,
            comboOptions: [
                {
                    value: 'allPrestations',
                    label: this.$t('combo.all_prestations'),
                    description: '',
                    isActive: false,
                },
                {
                    value: 'specificPrestation',
                    label: this.$t('combo.specific_prestation_label'),
                    description: this.$t('combo.specific_prestation_desc'),
                    isActive: true,
                },
                {
                    value: 'family',
                    label: this.$t('combo.family_label'),
                    description: this.$t('combo.family_desc'),
                    isActive: true,
                },
            ],
            someTimeOptions: [
                {
                    value: true,
                    label: this.$t('common.yes'),
                    description: this.$t('combo.same_time_yes_desc'),
                    isActive: true,
                },
                {
                    value: false,
                    label: this.$t('common.no'),
                    description: this.$t('combo.same_time_no_desc'),
                    isActive: true,
                },
            ],
            isOrderRequiredOptions: [
                {
                    value: true,
                    label: this.$t('common.yes'),
                    description: this.$t('combo.order_required_yes_desc'),
                    isActive: true,
                },
                {
                    value: false,
                    label: this.$t('common.no'),
                    description: this.$t('combo.order_required_no_desc'),
                    isActive: true,
                },
            ],
            multiParticipantsOptions: [
                {
                    value: true,
                    label: this.$t('common.yes'),
                    description: this.$t('combo.multi_participants_yes_desc'),
                    isActive: true,
                },
                {
                    value: false,
                    label: this.$t('common.no'),
                    description: this.$t('combo.multi_participants_no_desc'),
                    isActive: true,
                },
            ],
            remisePercentOptions: [
                {
                    value: true,
                    label: this.$t('common.yes'),
                    description: this.$t('combo.same_time_yes_desc'),
                    isActive: true,
                },
                {
                    value: false,
                    label: this.$t('common.no'),
                    description: this.$t('combo.same_time_no_desc'),
                    isActive: true,
                },
            ],
            depositTypes: [
                { value: 'percentage', label: this.$t('combo.percentage') + '(%)' },
                { value: 'amount', label: this.$t('combo.amount') + ' (' + this.$symbolCurrency + ')' },
            ],
            countryVATRates: [],
            discountTypes: [{ value: 'percentage' }, { value: 'amount' }],
            symbol_currency: window.symbolCurrency || '€',
            errors: {},
            comboItems: [{ selectedActivity: null, selectedDuration: null }],
            isCalculating: false,
            maxcomboItems: 100, // Max number of combo items
            editor: ClassicEditor,
            descriptionEditorInstance: null,
            selectedItemIndex: null,
            isModalVisible: false,
            descriptions: {
                general: this.$t('combo.descriptions.general'),
                slot_succession: this.$t('combo.descriptions.slot_succession'),
                same_time: this.$t('combo.descriptions.same_time'),
                remise_percent: this.$t('combo.descriptions.remise_percent'),
                remise_percent_active: this.$t('combo.descriptions.remise_percent_active'),
                item_qty_min: this.$t('combo.descriptions.item_qty_min'),
                item_qty_max: this.$t('combo.descriptions.item_qty_max'),
            },
        }
    },

    computed: {
        ticketsAsOption() {
            return this.comboItems[this.selectedItemIndex]?.selectedActivity?.tickets_as_option || []
        },

        ticketsAsOptionSelectedDurationId() {
            return this.comboItems[this.selectedItemIndex]?.selectedDuration?.id || 0
        },

        areDurationsSame() {
            const comboItems = this.comboItems
            if (!comboItems?.length) return true

            const firstDuration = comboItems[0]?.selectedDuration?.duration || undefined

            if (firstDuration === undefined) return true

            return comboItems.every((activity) => {
                const duration = activity.selectedDuration?.duration
                if (duration == null || duration === '') return true
                return duration === firstDuration
            })
        },

        filteredTags() {
            const selectedPackages = Array.isArray(this.formData.selected_tags) ? this.formData.selected_tags : []

            const selectedIds = selectedPackages.reduce((acc, selected) => {
                acc[selected.id] = true
                return acc
            }, {})

            return this.tags.filter((option) => !selectedIds[option.id])
        },

        hasNullSelectedDuration() {
            return this.comboItems.some((item) => item.selectedDuration?.id === null)
        },
    },

    methods: {
        hasTicketsOptions(index = null) {
            index = index ?? this.selectedItemIndex
            return index != null && this.comboItems[index]?.selectedActivity?.tickets_as_option?.length > 0
        },

        handleDepositeChange() {
            if (!this.formData.deposite) {
                this.formData.deposite_type = ''
                this.formData.deposite_value = ''
                this.errors = {}
            }
        },

        shortDescription(description) {
            return description.split(' ').slice(0, 10).join(' ') + '...'
        },

        showFullDescription(description) {
            alert(description) // Remplacer par un modal ou un tooltip
        },

        async initializeFormData() {
            try {
                const fetchedData = await this.initFormData()
                this.formData = { ...this.formData, ...fetchedData }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        initFormData() {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({
                        name: '',
                        description: '',
                        visible_online: true,
                        type: 'specificPrestation',
                        is_same_time: false,
                        is_multi_participants: false,
                        slot_succession: null,
                        is_by_percent: false,
                        is_order_required: false,
                    })
                }, 50)
            })
        },

        handleImageUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.formData.image = e.target.result
                    this.imagePreview = URL.createObjectURL(file)
                }
                reader.readAsDataURL(file)
            }
        },

        ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },

        validateSlotSuccession() {
            if (this.formData.slot_succession != '' && this.formData.slot_succession == 0) {
                this.errors.slot_succession = this.$t('combo.cannot_be_zero')
            } else {
                this.errors.slot_succession = null
            }
        },

        validateItemQtyMin() {
            if (this.formData.item_qty_min != '' && this.formData.item_qty_min == 0) {
                this.errors.item_qty_min = this.$t('combo.cannot_be_zero')
            } else {
                this.errors.item_qty_min = null
            }
        },

        validateItemQtyMax() {
            if (this.formData.item_qty_max != '' && this.formData.item_qty_max == 0) {
                this.errors.item_qty_max = this.$t('combo.cannot_be_zero')
            } else {
                this.errors.item_qty_max = null
            }
        },

        calculatePrice() {
            const price = parseFloat(this.formData.price) || 0
            const vatRate = parseFloat(this.formData.vat_rate) || 0

            this.formData.price_ht = (price / (1 + vatRate / 100)).toFixed(this.$priceHtDecimals)
        },

        calculatePriceHT() {
            const priceHT = parseFloat(this.formData.price_ht) || 0
            const vatRate = parseFloat(this.formData.vat_rate) || 0

            this.formData.price = (priceHT * (1 + vatRate / 100)).toFixed(this.$priceDecimal)
        },

        onVatRateChange() {
            const vatRate = parseFloat(this.formData.vat_rate) || 0
            const priceHT = parseFloat(this.formData.price_ht) || 0
            const price = parseFloat(this.formData.price) || 0

            if (priceHT > 0) {
                this.formData.price = (priceHT * (1 + vatRate / 100)).toFixed(this.$priceDecimal)
            } else if (price > 0) {
                this.formData.price_ht = (price / (1 + vatRate / 100)).toFixed(this.$priceHtDecimals)
            }
        },

        dropdownShouldOpen(VueSelect) {
            return VueSelect.open
        },

        handleDropdownCheck() {
            if (this.hasTicketsOptions(this.selectedItemIndex)) {
                this.toggleModalTicketOption()
            }
        },

        onActivityChange(index, item) {
            item.selectedDuration = null
            this.selectedItemIndex = index
        },

        onPrestationOption(itemPrestation, option) {
            this.comboItems[this.selectedItemIndex].selectedDuration = {
                id: option.id,
                duration: option.duration,
                price: option.price,
                price_ht: option.price_ht,
                isTicketAsOption: true,
                ticketAsOption: {
                    id: itemPrestation.id,
                    name: itemPrestation.name,
                },
            }
            this.toggleModalTicketOption()
        },

        addCombo() {
            if (this.comboItems.length < this.maxcomboItems) {
                this.comboItems.push({ selectedActivity: null, selectedDuration: null })
            }
        },

        removeCombo(index) {
            if (this.comboItems.length >= 1) {
                this.comboItems.splice(index, 1)
            }
        },

        getAvailableActivitiesOld(currentIndex) {
            return this.prestations_with_prices_times.filter((activity) => {
                return !this.comboItems.some((item, index) => index !== currentIndex && item.selectedActivity?.id == activity.id)
            })
        },

        getAvailableActivities(index) {
            const isOnlyVR = this.formData?.is_same_time
            const selectedDuration = this.comboItems?.[0]?.selectedDuration?.duration ?? null
            const selectedSlotConfig = this.comboItems?.[0].selectedActivity?.slot_config ?? null

            // Filter out already selected activities and durations
            const usedDurations = this.comboItems
                .filter((comboItem, comboIndex) => comboIndex !== index && comboItem.selectedActivity?.id)
                .reduce((acc, comboItem) => {
                    if (comboItem.selectedActivity?.id && comboItem.selectedDuration?.id) {
                        acc.push({
                            activityId: comboItem.selectedActivity.id,
                            durationId: comboItem.selectedDuration.id,
                        })
                    }
                    return acc
                }, [])

            // Apply the family and duration filter logic
            return this.prestations_with_prices_times
                .filter((activity) => {
                    if (this.formData.is_same_time == true && selectedDuration != null && selectedSlotConfig != null) {
                        // Only include activities that have a matching duration
                        return activity.prices_by_times.some(
                            (time) => time.duration == selectedDuration && activity.slot_config == selectedSlotConfig
                        )
                    }
                    return true
                })
                .filter((activity) => {
                    if (isOnlyVR) {
                        return activity.subcategory?.slug === 'vr'
                    }
                    return true
                })
                .map((activity) => {
                    // Exclude used durations for the current activity
                    if (usedDurations.some((used) => used.activityId == activity.id)) {
                        const filteredDurations = activity.prices_by_times.filter((duration) => {
                            return !usedDurations.some((used) => used.activityId == activity.id && used.durationId == duration.id)
                        })
                        return { ...activity, prices_by_times: filteredDurations }
                    }
                    return activity
                })
        },

        getAvailableDurations(activity) {
            const selectedDuration = this.comboItems?.[0]?.selectedDuration?.duration ?? null
            if (this.formData.is_same_time == true && selectedDuration !== null) {
                return activity?.prices_by_times.filter((i) => i.duration == selectedDuration)
            }
            return activity ? activity?.prices_by_times : []
        },

        formatDurationPrice(duration, price) {
            return `${duration} min / ${price} (${this.$symbolCurrency})`
        },

        handleOptionChange(optValue) {
            const isFamily = (optValue == 'family' && optValue == true) || optValue == false
            if (optValue == 'specificPrestation' && this.comboItems.length == 0) {
                this.addCombo()
            } else if (optValue == 'allPrestations' || isFamily) {
                // this.comboItems = []
            }
            this.$forceUpdate()
        },

        handleSomeTimeOptionChange(optValue) {
            // if (optValue) { this.comboItems = [] }
            this.formData.remise_percent = null
            this.formData.is_same_time = optValue
            this.handleOptionChange(optValue)
            this.handleComboIsPercent()
        },

        handleMultiParticipantsOptionChange(optValue) {
            this.formData.remise_percent = null
            this.formData.is_multi_participants = optValue
            this.handleOptionChange(optValue)
            this.handleComboIsPercent()
        },

        handleComboOptionChange(optValue) {
            this.formData.remise_percent = null
            this.formData.is_multi_participants = false
            this.formData.is_same_time = false
            this.formData.type = optValue
            this.handleOptionChange(optValue)
            this.handleComboIsPercent()
        },

        handleIsRemisePercentActiveChange(optValue) {
            this.formData.remise_percent = null
            this.formData.is_remise_percent_active = optValue
            this.formData.remise_percent =
                optValue && this.data.remise_percent > 0 && this.data.remise_percent < 100 ? this.data.remise_percent : null
            this.handleComboIsPercent()
            this.$forceUpdate()
        },

        handleComboIsPercent() {
            this.formData.is_by_percent = this.formData.is_multi_participants
            if (this.formData.is_by_percent == true) {
                this.formData.price = 0
                this.formData.price_ht = 0
                this.formData.vat_rate = 0
            }
            this.$forceUpdate()
        },

        handleIsOrderRequiredChange(optValue) {
            this.formData.is_order_required = optValue
            this.$forceUpdate()
        },

        handleSubmit() {
            this.errors = {}
            this.handleComboIsPercent()
            if (this.formData.is_same_time && !this.areDurationsSame) {
                this.showErrorNotification(this.$t('combo.durations_mismatch'))
                return
            }
            if (this.formData.id) {
                this.update()
            } else {
                this.store()
            }
        },

        async store() {
            this.formData.comboItems = this.comboItems.map(({ selectedActivity, selectedDuration, isRequired }) => ({
                activityId: selectedActivity?.id || null,
                durationId: selectedDuration?.id || null,
                duration: selectedDuration?.duration || null,
                isTicketAsOption: selectedDuration?.isTicketAsOption || false,
                ticketAsOption: selectedDuration?.ticketAsOption || null,
                isRequired: isRequired || false,
            }))

            this.formData.description = this.descriptionEditorInstance.getData()

            axios
                .post('/back-office/package', this.formData)
                .then((response) => {
                    this.$toast.success(this.$t('combo.store_success'))
                    setTimeout(() => {
                        window.location.href = '/back-office/package'
                    }, 2000)
                })
                .catch((error) => {
                    console.error('Error creating package:', error)
                    this.showErrors(error.response)
                })
        },

        async update() {
            const _id = this.data.id
            this.formData.comboItems = this.comboItems.map(({ selectedActivity, selectedDuration, isRequired }) => ({
                activityId: selectedActivity?.id || null,
                durationId: selectedDuration?.id || null,
                duration: selectedDuration?.duration || null,
                isTicketAsOption: selectedDuration?.isTicketAsOption || false,
                ticketAsOption: selectedDuration?.ticketAsOption || null,
                isRequired: isRequired || false,
            }))

            this.formData.description = this.descriptionEditorInstance.getData()

            axios
                .put(`/back-office/package/${_id}`, this.formData)
                .then((response) => {
                    this.$toast.success(this.$t('combo.update_success'))
                })
                .catch((error) => {
                    console.error('Error updating package:', error)
                    this.showErrors(error.response) // Display error messages
                })
        },

        showErrors(response) {
            this.errors = {}
            if (response && response.data && response.data.errors) {
                const errors = response.data.errors
                for (const key in errors) {
                    let errorMessage = errors[key][0]
                    if (key.startsWith('comboItems.')) {
                        const parts = key.split('.')
                        const index = parts[1]
                        errorMessage = errorMessage.replace(':index', parseInt(index) + 1)
                        if (!this.errors.comboItems) {
                            this.$set(this.errors, 'comboItems', [])
                        }
                        if (!this.errors.comboItems[index]) {
                            this.$set(this.errors.comboItems, index, {})
                        }
                        this.$set(this.errors.comboItems[index], key.split('.')[2], errorMessage)
                    } else {
                        this.$set(this.errors, key, errorMessage)
                    }
                    this.showErrorNotification(errorMessage)
                }
            } else {
                this.showErrorNotification(this.$t('common.error_occurred'))
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },

        toggleModalTicketOption(index = null) {
            this.selectedItemIndex = index ?? this.selectedItemIndex
            if (this.isModalVisible) {
                this.$modal.hide('modal-ticket-options')
            } else {
                this.$modal.show('modal-ticket-options')
            }
            this.isModalVisible = !this.isModalVisible
        },
    },

    created() {
        // this.initializeFormData();
    },

    mounted() {
        if (Object.keys(this.data).length !== 0) {
            this.formData = {
                ...this.data,
                is_same_time: this.data?.is_same_time ?? false,
                is_order_required: this.data?.is_order_required ?? false,
            }
        }

        this.imagePreview = this.formData?.image ?? null
        this.comboItems = this.package_items.map((item) => ({
            selectedActivity: {
                id: item.item_id,
                name: item.itemable.name,
                slot_config: item.itemable.slot_config,
                prices_by_times: item.itemable.prices_by_times || [],
                tickets_as_option: item.itemable.tickets_as_option || [],
            },

            selectedDuration: {
                prestation_id: null,
                id: item?.prices_by_time?.id ?? null,
                price: item?.prices_by_time?.price ?? null,
                price_ht: item?.prices_by_time?.price_ht ?? null,
                duration: item?.prices_by_time?.duration ?? null,
                isTicketAsOption: item?.prestation_option ? true : false,
                ticketAsOption: {
                    id: item?.prestation_option?.item.id ?? null,
                    name: item?.prestation_option?.item?.name ?? null,
                },
            },

            isRequired: item?.is_required ?? false,
        }))

        this.formData.is_remise_percent_active = this.formData.remise_percent != null ? true : false

        if (this.editor && this.$refs.editor) {
            this.editor
                .create(this.$refs.editor, {
                    link: {
                        decorators: {
                            openInNewTab: {
                                mode: 'manual',
                                label: this.$t('combo.open_in_new_tab'),
                                attributes: {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                },
                            },
                        },
                    },
                })
                .then((instance) => {
                    this.descriptionEditorInstance = instance
                    instance.setData(this.formData.description)
                })
        }

        this.handleComboIsPercent()
    },

    components: {
        vSelect,
        BaseSwitch,
    },
}
</script>

<style scoped>
.invalid-feedback {
    color: #dc3545;
    font-size: 0.875em;
    margin-top: 0.25em;
    display: block;
    line-height: 1.25;
}

.is-invalid {
    border-color: #dc3545;
    background-color: #f8d7da;
    color: #721c24;
}

.is-invalid ~ .invalid-feedback {
    display: block;
}

.new-image {
    background: #f8fafc;
    padding: 33px 0 8px;
}

.radio-container {
    color: white;
    cursor: pointer;
    padding: 0.2rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
}

.combo-selected-container {
    background-color: rgba(98, 194, 246, 0.08);
    border: 1px solid rgba(98, 194, 246, 1);
}

/* Hide the default radio button */
.combo-items-radio {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.combo-items-radio + label {
    position: relative;
    padding-left: 50px;
    cursor: pointer;
    display: inline-block;
    color: black;
    /* Default label color */
}

.radio-description {
    padding-left: 50px;
    font-size: 0.8rem;
    cursor: pointer;
}

.combo-items-radio + label::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 50%;
    width: 20px;
    height: 20px;
    border: 2px solid rgba(98, 194, 246, 1);
    border-radius: 50%;
    background-color: white;
}

/* Custom radio button checked state */
.combo-items-radio:checked + label::before,
.combo-items-radio-selected + label::before {
    background-color: rgba(98, 194, 246, 1);
}

.combo-items-radio:checked + label,
.combo-items-radio-selected + label {
    color: rgba(98, 194, 246, 1);
    /* Label color when selected */
}

/* Disabled label styling */
.combo-items-radio:disabled + label {
    color: #b0b0b0;
    /* Light gray for disabled text */
    cursor: not-allowed;
    /* Change cursor to indicate unavailability */
}

/* Disabled custom radio button styling */
.combo-items-radio:disabled + label::before {
    border-color: #e0e0e0;
    /* Light gray border */
    background-color: #f5f5f5;
    /* Light background color for disabled */
    cursor: not-allowed;
}

/* Disabled description styling */
.combo-items-radio:disabled ~ .radio-description {
    color: #b0b0b0;
    /* Light gray for the description text */
}

/* Disabled container styling */
.radio-container.combo-selected-container:has(input:disabled) {
    background-color: #f8f9fa;
    /* Neutral background for disabled selected option */
    border-color: #e0e0e0;
    /* Lighter border color */
    cursor: not-allowed;
}

.vm--modal {
    background-color: #f8fafc !important;
    padding: 1.5rem !important;
}

.modal-ticket-option-list {
    overflow-y: auto;
    height: calc(100% - 50px);
    padding: 3rem 4rem;
}

.btn-exit {
    position: absolute;
    top: 10px;
    right: 16px;
    display: flex;
    width: 45px;
    height: 45px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #f8fafc !important;
    margin: 15px;
}

table {
    width: 100%;
    /* border-collapse: collapse; */
}

th {
    text-align: left;
    padding: 1rem;
    border-bottom: 1px solid #ccc;
}

tbody tr {
    border-bottom: 1px solid #ccc;
}

tbody tr:last-child {
    border-bottom: none;
}

td {
    padding: 1rem;
}

.ticket-option-toggle {
    float: inline-end;
}

.ticket-option-toggle:hover {
    color: #7d2dbd;
}

.text-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
    padding: 10px;
    border-radius: 5px;
}

.fa-info-circle {
    color: #007bff;
    transition: color 0.3s ease;
}

.fa-info-circle:hover {
    color: #0056b3;
}
</style>
